import { Helmet } from 'react-helmet-async';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Contact from '@/pages/home/components/Contact';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-black">
      <Helmet>
        <title>Contact HUB30 | Find Us in Jbeil, Lebanon | Opening Hours & Location</title>
        <meta
          name="description"
          content="Get in touch with HUB30 gym in Jbeil (Byblos), Lebanon. Find us on the map, call via WhatsApp, or drop by. Open Mon–Fri 5:45 AM–10 PM, Sat 7 AM–3 PM."
        />
        <meta
          name="keywords"
          content="HUB30 contact, gym Jbeil location, gym Byblos address, HUB30 opening hours, gym Lebanon phone number, gym near me Jbeil"
        />
        <link rel="canonical" href="https://hub30gym.com/contact" />
        <meta property="og:title" content="Contact HUB30 Gym | Jbeil (Byblos), Lebanon" />
        <meta property="og:description" content="HUB30 gym in Jbeil — find our location, opening hours, and contact details. Open Mon–Fri 5:45 AM–10 PM, Sat 7 AM–3 PM." />
        <meta property="og:url" content="https://hub30gym.com/contact" />
      </Helmet>
      <Navbar />
      <div className="pt-20">
        <Contact />
      </div>
      <Footer />
    </div>
  );
}
